module.exports = __webpack_public_path__ + "img/mobile-12.a81db3d3.png";